<template>
  <v-app>
    <v-snackbar v-model="show" :color="color">
      {{ message }}
    </v-snackbar>
    <n-config-provider :locale="ptBR" :date-locale="datePtBR">
      <router-view />
    </n-config-provider>
    <GlobalLoading />
    <GlobalLoadingOverlay />
  </v-app>
</template>

<script setup>
import { useToastStore } from '@/store/toast';
import GlobalLoading from '@/components/GlobalLoading.vue';
import GlobalLoadingOverlay from '@/components/GlobalLoadingOverlay.vue';

import { NConfigProvider } from 'naive-ui';
import { ptBR, datePtBR } from 'naive-ui/es/locales';

import { toRefs } from 'vue';

const toastStore = useToastStore();
const { show, color, message } = toRefs(toastStore);
</script>

<style>
/* Your styles here */
</style>